export const sortByName = [{ id: 'name' }];
